'use strict';

angular.module('licensure.services')
    .factory('Correspondences', ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {
        var prepareArrayField = function (obj) {
            var result = '';
            if (obj != null) {
                for (var i = 0, l = obj.length; i < l; i++) {
                    if (i > 0) {
                        result = result + ',' + obj[i].id;
                    } else {
                        result = obj[i].id;
                    }
                }
            }
            return result;
        };

        return {
            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Correspondences/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (correspondence, args) {
                var d = $q.defer();

                var correspondenceData = angular.extend({}, {
                    mergeEntityID: correspondence.merge_entity_id,
                    message: correspondence.message,
                    subject: correspondence.subject,
                    from_address: prepareArrayField(correspondence.from_address),
                    to_address: prepareArrayField(correspondence.to_address),
                    cc_address: prepareArrayField(correspondence.cc_address),
                    bcc_address: prepareArrayField(correspondence.bcc_address),
                    replyTo_address: prepareArrayField(correspondence.replyto_address),
                    userDocumentIDs: prepareArrayField(correspondence.include_documents),
                    mergeTemplateID: correspondence.merge_template_id,
                    save_correspondence_object: true,
                    sendTemplate: 0,
                    saveDataObjects: true,
                    enterpriseID: $rootScope.enterpriseID,
                    initiatedByID: $rootScope.userID,
                    respondEmail: false
                }, args);


                let request;
                if (args && Object.hasOwn(args, "complaintID")) {
                    request = {
                        method: 'POST',
                        url: apiLocation + '/api/InvestigationsModule/Investigation/Correspondence/Send',
                        data: correspondenceData
                    };
                } else {
                    request = {
                        method: 'POST',
                        url: $rootScope.internalURL + 'controller.cfm?method=CorrespondenceService.sendCorrespondenceAngularJS&returnFormat=json',
                        data: correspondenceData
                    };
                }

                $http(request)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        const errorMessage = typeof response.data === 'string'
                            ? response.data
                            : (response.data && response.data.message) || "An error occurred saving the correspondence.";
                        d.reject({message: errorMessage});
                    });

                return d.promise;
            },

            downloadZIP: function (correspondenceIds) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Core/Correspondence/Zip', { correspondenceIds: correspondenceIds }).
                    then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        const errorMessage = typeof response.data === 'string'
                            ? response.data
                            : (response.data && response.data.message) || "An error occurred downloading the ZIP.";
                        d.reject({message: errorMessage});
                    });

                return d.promise;
            }
        }
    }])
;